import { memo } from 'react';
import { Button, Icon } from '@chakra-ui/react';

import { NavigationButtonProperties } from '../types';
import { COLORS, BUTTON_STYLES } from '../constants';

const NavigationButton = memo(({ icon, label, isActive, onClick }: NavigationButtonProperties) => {
  return (
    <Button
      leftIcon={
        <Icon as={icon} boxSize={5} color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT} />
      }
      variant='ghost'
      {...BUTTON_STYLES}
      borderRadius={isActive ? '9999px' : BUTTON_STYLES.borderRadius}
      color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT}
      bg={isActive ? COLORS.ACTIVE_BG : 'transparent'}
      flexShrink={0}
      _hover={{ bg: isActive ? COLORS.ACTIVE_HOVER : 'gray.100' }}
      _active={{ bg: isActive ? COLORS.ACTIVE_PRESSED : 'gray.200' }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
});

NavigationButton.displayName = 'NavigationButton';

export default NavigationButton;
